export default __webpack_public_path__ + "static/media/defaultPropGameImage.c89c3875.png";